"use strict";

import { throttle } from "throttle-debounce";

(function () {
  const HEADER_ELEMENT = document.querySelector(".js--header");
  const throttleDelay = 350;
  const isScrolledClass = "is-scrolled";
  const scrollHeight = 10;

  if (HEADER_ELEMENT) {
    window.addEventListener(
      "scroll",
      throttle(throttleDelay, () => handleHeaderScroll()),
      { passive: true },
    );
  }

  function handleHeaderScroll() {
    if (scrollHeight < document.documentElement.scrollTop) {
      HEADER_ELEMENT.classList.add(isScrolledClass);
      return;
    }

    HEADER_ELEMENT.classList.remove(isScrolledClass);
  }
})();
